import React from 'react';
import SectionH2 from '../heading/SectionH2';
import ExpandableFAQ from '../core/ExpandableFAQ';

const BusinessFAQ = ({ theme = 'dark' }) => {
  return (
    <div class="flex flex-row justify-center px-10">
      <div class="flex max-w-7xl flex-col sm:flex-row">
        <div class="sm:w-1/3">
          <div class="flex flex-col items-center pb-5 pt-1 sm:pb-16">
            <SectionH2
              customAlignment={'text-center sm:text-left'}
              title={'Frequently Asked Questions'}
              theme={theme}
            />
          </div>
        </div>
        <div class="flex-row justify-center space-y-4 sm:flex sm:w-2/3 sm:flex-none sm:gap-4 sm:space-y-0">
          <div class="flex flex-col gap-4 sm:flex-col sm:flex-wrap">
            <ExpandableFAQ
              expanded={true}
              title={'Can I manage multiple buildings from one account?'}
              descriptions={[
                'Yes. Add each building in the Lowkey app and switch between them instantly, no separate logins.',
                'Every building gets its own virtual number, passcodes, routines, and activity history, all managed from a single account.',
              ]}
              theme={theme}
            />
            <div class="sm:hidden">
              <ExpandableFAQ
                expanded={false}
                title={'Is the Lowkey app secure?'}
                descriptions={[
                  'Yes, the Lowkey app is designed to be secure and protect your privacy. All communication between the app and the buzzer is encrypted to ensure the security of your building and the privacy of your personal information.',
                  'Lowkey also includes an Activity History feature that helps to further ensure the security of your building. This feature allows you to view a record of all activity, including when individuals have accessed the building and when they have been granted access.',
                ]}
                theme={theme}
              />
            </div>
            <ExpandableFAQ
              expanded={false}
              title={'Do I need to install new hardware?'}
              descriptions={[
                'No. Lowkey is software, each building gets a virtual number that its existing buzzer dials instead of a personal phone.',
                'If the buzzer can dial a phone number, it works with Lowkey. There is nothing to mount, wire, or maintain.',
              ]}
              theme={theme}
            />
            <ExpandableFAQ
              expanded={false}
              title={'What is a virtual number?'}
              descriptions={[
                'A virtual number is a phone number that is not tied to a specific physical phone or SIM card. Instead, it is a virtual number that is associated with your Lowkey account and is used to interface securely with your buzzer system.',
              ]}
              theme={theme}
            />
            <ExpandableFAQ
              expanded={false}
              title={'How does pricing work for multiple buildings?'}
              descriptions={[
                'The Business plan is $250/year base plus $250/year for each building you manage, billed annually.',
                'You can add or remove buildings at any time, and your billing adjusts automatically.',
              ]}
              theme={theme}
            />
          </div>
          <div class="flex flex-col gap-4 sm:flex-col sm:flex-wrap">
            <div class="hidden sm:flex">
              <ExpandableFAQ
                expanded={false}
                title={'Is the Lowkey app secure?'}
                descriptions={[
                  'Yes, the Lowkey app is designed to be secure and protect your privacy. All communication between the app and the buzzer is encrypted to ensure the security of your building and the privacy of your personal information.',
                  'Lowkey also includes an Activity History feature that helps to further ensure the security of the building. This feature allows you to view a record of all activity, including when individuals have accessed the building and when they have been granted access.',
                ]}
                theme={theme}
              />
            </div>
            <ExpandableFAQ
              expanded={false}
              title={'Is Lowkey compatible with all buzzer systems?'}
              descriptions={[
                'Yes, Lowkey is designed to work with all buzzer systems that dial a phone number. As long as your buzzer is set up to dial a phone number, you can use the Lowkey app to control it.',
              ]}
              theme={theme}
            />
            <ExpandableFAQ
              expanded={false}
              title={'How do I get started?'}
              descriptions={[
                'Download the Lowkey app, start your 14 day trial, and add your buildings, each one gets its own virtual number.',
                'Managing a large portfolio? Reach out and we can help you get set up.',
              ]}
              theme={theme}
            />
            <div class="hidden sm:flex">
              <ExpandableFAQ
                expanded={false}
                title={'Can my team help manage the buildings?'}
                descriptions={[
                  'Yes. Invite teammates to your account and they can log in across devices to manage buildings together.',
                  'They can also answer buzzer calls and grant access from their own phones when passcodes are not activated.',
                ]}
                theme={theme}
              />
            </div>
            <div class="hidden sm:flex">
              <ExpandableFAQ
                expanded={false}
                title={'How does the Passcode feature work?'}
                descriptions={[
                  'Passcodes are 3-4 digits and can be created, changed, or revoked at any time, make as many as you need for each building.',
                  'Share a passcode with anyone you want to grant access. When they dial the unit on the buzzer, they are prompted to enter the passcode on the buzzer dialpad to be let in.',
                ]}
                theme={theme}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessFAQ;
